module.exports = __webpack_public_path__ + "static/Brasil-f77bdacbd549242a3479675ddda6a037.png";